module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.addons && _vm.times && _vm.base) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 program-page-overview-multicare"
  }, [(!_vm.isQuickAdd && (!_vm.simulate || (_vm.simulate && _vm.simulate.code == undefined)) && (_vm.current && _vm.current.package_state_id == 2)) ? _c('div', {
    staticClass: "price-box-fixed",
    class: {
      'price-calculated': _vm.simulate && _vm.simulate.individual_cost
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(!_vm.individual_days && _vm.simulate && _vm.simulate.individual_cost > 0 && _vm.simulate.original_cost_calculation.length > 0) ? _c('span', {
    staticClass: "price"
  }, [_c('b', [_vm._v(_vm._s(_vm.locale.text_total_price))]), _vm._v(" "), _c('i', [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.simulate.individual_cost)))])]) : (_vm.simulate && _vm.simulate.code == 500) ? _c('span', {
    staticClass: "price"
  }, [_c('b', [_vm._v("Something went wrong!")])]) : (_vm.current && (_vm.selection.packages.length == 0 || _vm.selection.participants.length == 0)) ? _c('span', {
    staticClass: "price"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.config.use_short_weeks && _vm.individual_days ? _vm.locale.text_total_price : ((!_vm.individual_days) || (_vm.individual_days && _vm.selection.days_running.length > 0) ? 'From' : '')))]), _vm._v(" "), _c('i', [_vm._v(_vm._s((!_vm.individual_days ? (_vm.fromPrice !== null ? _vm.currencyFormat(_vm.fromPrice) : _vm.currencyFormat(_vm.current.price)) : (_vm.selection.days_running.length > 0 ? _vm.currencyFormat(_vm.individual_days_from_price) : ' '))))])]) : (!_vm.individual_days && _vm.simulate && parseFloat(_vm.simulate.individual_cost) > 0) ? _c('span', {
    staticClass: "price"
  }, [_c('b', [_vm._v(_vm._s(_vm.locale.text_total_price))]), _vm._v(" "), _c('i', [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.simulate.individual_cost)))])]) : _c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.individual_days && this.venue && this.venue.venue_notes) ? _c('div', [_c('div', {
    staticClass: "content-block-alone darker startScrolling",
    staticStyle: {
      "background": "#fbc51e"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.text_notes_title) + " : " + _vm._s(this.venue.venue_notes))])])])]) : _vm._e(), _vm._v(" "), (_vm.individual_days && this.programmes && this.programmes.length > 0 && this.programmes.some(function (programme) { return programme.availability && Object.values(programme.availability).some(function (num) { return num <= 0; }) && (programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18); })) ? _c('div', [(!_vm.isQuickAdd) ? _c('div', {
    staticClass: "content-block-alone darker startScrolling",
    staticStyle: {
      "background-color": "#e41b13"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.text_availability_title) + " : "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_subscribe_to_notify_short_week)
    }
  })])])]) : _c('div', {
    staticClass: "fields dropdown"
  }, [_c('label', {
    staticStyle: {
      "background-color": "#e41b13"
    }
  }, [_vm._v(_vm._s(_vm.locale.text_availability_title) + " : "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_subscribe_to_notify_short_week)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.individual_days) ? _c('div', {
    staticClass: "content-block-alone"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionsHeader)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.individual_days) ? _c('div', {
    staticClass: "content-block-alone flexicare-description"
  }, [_c('div', {
    staticClass: "full-width add-on-block-outer"
  }, [_c('div', {
    staticClass: "box-layout-inner add-on-block"
  }, [_c('div', {
    staticClass: "full-width-field-block"
  }, [_c('div', {
    staticClass: "add-on-checkbox-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "content-block",
    domProps: {
      "innerHTML": _vm._s(_vm.base.full_description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-image",
    style: ({
      background: 'url(' + _vm.base.image_url + ') center center / contain no-repeat'
    })
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form",
    attrs: {
      "id": "multicareBooking"
    }
  }, [(_vm.individual_days) ? _c('span', {
    staticClass: "startScrolling",
    class: {
      'individual-left': !this.isQuickAdd, 'individual_days': !_vm.$root.config.use_short_weeks, 'short_weeks': _vm.$root.config.use_short_weeks
    }
  }, [(_vm.individual_days && ((this.venue && !(this.venue.id == 257 || this.venue.id == 281 || this.venue.id == 157 || this.venue.id == 75)) || (!this.venue || this.venue === undefined))) ? _c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.$root.config.use_short_weeks) ? _c('short-weeks-selection', {
    attrs: {
      "current": _vm.current,
      "toSwap": _vm.toSwap,
      "packages": _vm.addons,
      "selection": _vm.selection
    }
  }) : _c('individual-days-selection', {
    attrs: {
      "current": _vm.current,
      "toSwap": _vm.toSwap,
      "packages": _vm.addons,
      "selection": _vm.selection
    },
    on: {
      "reload": _vm.load
    }
  })], 1) : _c('span', [(_vm.current && _vm.current.availability && Object.values(_vm.current.availability).some(function (num) { return num <= 0; }) && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18)) ? _c('div', [(!_vm.isQuickAdd) ? _c('div', {
    staticClass: "content-block-alone darker startScrolling",
    staticStyle: {
      "background-color": "#e41b13"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "color": "white"
    },
    domProps: {
      "innerHTML": _vm._s('One or more of the ' + _vm.current.start_date.toDate().formatRange(_vm.current.days_running, false) + ' ' + _vm.locale.text_individual_days_sold_out + '<br>' + _vm.locale.text_subscribe_to_notify)
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.venue && this.venue.venue_notes) ? _c('div', [(!_vm.isQuickAdd) ? _c('div', {
    staticClass: "content-block-alone darker startScrolling",
    staticStyle: {
      "background": "#fbc51e"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.text_notes_title) + " : " + _vm._s(this.venue.venue_notes))])])]) : _c('div', {
    staticClass: "fields dropdown"
  }, [_c('label', [_vm._v(_vm._s(_vm.locale.text_notes_title) + " : " + _vm._s(this.venue.venue_notes))])])]) : _vm._e(), _vm._v(" "), (_vm.current.availability && _vm.current.availability !== undefined && (Object.values(_vm.current.availability).some(function (num) { return num < 10; }) && Object.values(_vm.current.availability).every(function (num) { return num > 0; }) && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18))) ? _c('div', [(!_vm.isQuickAdd) ? _c('div', {
    staticClass: "content-block-alone darker startScrolling",
    staticStyle: {
      "background-color": "#e41b13"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.text_availability_title) + " : Limited availability remaining at this venue, on this week. Book to secure your place.")])])]) : _c('div', {
    staticClass: "fields dropdown"
  }, [_c('label', [_vm._v(_vm._s(_vm.locale.text_availability_title) + " : Limited availability remaining at this venue, on this week. Book to secure your place.")])])]) : _vm._e(), _vm._v(" "), (!_vm.isQuickAdd) ? _c('div', {
    staticClass: "content-block-alone"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.text_programme_title))])])]) : _c('div', {
    staticClass: "fields dropdown"
  }, [(_vm.addons.length > 0) ? _c('label', [_vm._v(_vm._s(_vm.locale.text_programme_title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-layout-inner course-list-blocks"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.addons), function(addon, key) {
    return _c('addon-selection', {
      key: key,
      attrs: {
        "locale": _vm.locale,
        "baseProgramme": _vm.optionsHeader,
        "selection": _vm.selection,
        "current": _vm.current,
        "base": _vm.base,
        "package": addon,
        "checked": _vm.addons.length == 1 || addon.id == (_vm.toSwap ? _vm.current.package_id : _vm.current.id)
      }
    })
  }))], 1)]), _vm._v(" "), (!this.isQuickAdd) ? _c('div', {
    staticClass: "content-block-alone",
    class: {
      'individual-right': _vm.individual_days
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.text_participant_title))])])]) : _vm._e(), _vm._v(" "), (!this.isQuickAdd) ? _c('div', {
    staticClass: "box-layout-inner attending",
    class: {
      'individual-right': _vm.individual_days
    }
  }, [_c('whos-attending', {
    attrs: {
      "current": _vm.current,
      "bookingId": _vm.$root.getCookie('kingscamps_booking_id'),
      "selection": _vm.selection
    },
    on: {
      "addchosen": _vm.addParticipant,
      "removechosen": _vm.removeParticipant
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.simulate && _vm.simulate.code != undefined && _vm.simulate.message.indexOf('Not authorised') > -1) ? _c('div', {
    staticClass: "box-layout-inner yellow"
  }, [_c('div', {
    staticClass: "half-half"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "price-subtotal alerts"
  }, [_c('span', [_vm._v(_vm._s(_vm.locale.text_not_authorised))])])])])]) : (_vm.simulate && _vm.simulate.code != undefined) ? _c('div', {
    staticClass: "box-layout-inner alert"
  }, [_c('div', {
    staticClass: "half-half blue"
  }, [_c('div', {
    staticClass: "full-width dark-red"
  }, [_c('div', {
    staticClass: "price-subtotal"
  }, [_c('span', [_vm._v(_vm._s(_vm.simulate.message))])])])])]) : (_vm.simulate && _vm.simulate.individual_cost != null && (_vm.current.prog_id != 1 || (!this.individual_days && _vm.current.availability && Object.values(_vm.current.availability).every(function (num) { return num > 0; }) && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18)) || (this.individual_days && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18)))) ? _c('div', {
    staticClass: "box-layout-inner dark-blue financial-summary cart-totals stopScrolling"
  }, [(_vm.isEditing && _vm.toSwap || _vm.isQuickAdd) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4"
  }, [_c('router-link', {
    staticClass: "cta-button blue",
    attrs: {
      "to": {
        name: 'cart.basket'
      }
    }
  }, [_vm._v("Go back (Discard changes)")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6 cart-totals",
    class: {
      'col-sm-6 col-sm-offset-6 col-md-offset-6 col-lg-offset-6': !_vm.toSwap && !_vm.isQuickAdd, 'col-sm-6 col-md-offset-2 col-lg-offset-2': _vm.toSwap || _vm.isQuickAdd
    },
    attrs: {
      "col-sm-12": ""
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.simulate.original_cost && (_vm.fees.length > 0 || _vm.discounts.length > 0)) ? _c('div', {
    key: "basket-total",
    staticClass: "basket-subtotal"
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal price-original-total"
  }, [_c('span', {
    staticClass: "vertical"
  }, [_vm._v(_vm._s(_vm.locale.text_original_price) + ": ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal price-original-total"
  }, [(_vm.simulate.original_cost) ? _c('b', {
    staticClass: "vertical"
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.simulate.original_cost)))]) : _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x"
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fees), function(fee) {
    return (_vm.fees.length > 0) ? _c('div', {
      key: "fee-container",
      staticClass: "fee-container"
    }, [_c('div', {
      staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box"
    }, [_c('b', [_vm._v(_vm._s(fee.discount_description) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box"
    }, [_c('b', [_vm._v(_vm._s(_vm.currencyFormat(fee.discount_amount)))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.discounts), function(discount, discountId) {
    return (_vm.discounts.length > 0) ? _c('div', {
      key: 'discount-container' + discountId,
      staticClass: "discount-container"
    }, [(discount.discount_amount > 0) ? _c('div', [_c('div', {
      staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box"
    }, [_c('b', [_vm._v(_vm._s(discount.discount_description) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box"
    }, [_c('b', [_vm._v("- " + _vm._s(_vm.currencyFormat(discount.discount_amount)))])])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.simulate.individual_cost != null) ? _c('div', {
    key: "basket-total-2",
    staticClass: "basket-total"
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal"
  }, [(_vm.fees.length > 0 || _vm.discounts.length > 0) ? _c('span', {
    staticClass: "vertical"
  }, [_vm._v(_vm._s(_vm.locale.text_total_price) + ": ")]) : _c('span', {
    staticClass: "vertical"
  }, [_vm._v(_vm._s(_vm.locale.text_total_price) + " \n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal"
  }, [(_vm.simulate.individual_cost != null) ? _c('b', {
    staticClass: "vertical"
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.simulate.individual_cost)))]) : _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.simulate.individual_cost != null && (_vm.current.prog_id != 1 || (!this.individual_days && _vm.current.availability && Object.values(_vm.current.availability).every(function (num) { return num > 0; }) && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18)) || (this.individual_days && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18)))) ? _c('div', {
    key: "checkout-cta",
    staticClass: "checkout-cta"
  }, [(!_vm.progressing) ? _c('input', {
    staticClass: "cta-button red checkout",
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.isEditing && _vm.toSwap ? 'Make Changes' : 'Add to basket') + (_vm.disabled ? ' (No changes)' : '')
    },
    on: {
      "click": _vm.progress
    }
  }) : _c('button', {
    staticClass: "cta-button red checkout disabled",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }), _vm._v("  Please wait")])]) : _vm._e()], 2)], 1)]) : _c('div', {
    staticClass: "box-layout-inner yellow"
  }, [_c('div', {
    staticClass: "half-half"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "price-subtotal alerts"
  }, [(_vm.current && (Object.values(_vm.current.availability).some(function (num) { return num <= 0; }) && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18)) && !_vm.individual_days) ? _c('span', {
    staticClass: "vertical"
  }, [_c('p', {
    staticStyle: {
      "color": "white!important"
    },
    domProps: {
      "innerHTML": _vm._s('One or more of the ' + _vm.current.start_date.toDate().formatRange(_vm.current.days_running, false) + ' ' + _vm.locale.text_individual_days_sold_out + '<br>' + _vm.locale.text_subscribe_to_notify)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.individual_days && _vm.current && (Object.values(_vm.current.availability).every(function (num) { return num <= 0; }) && (_vm.current.prog_id == 1 || _vm.current.prog_id == 17 || _vm.current.prog_id == 18))) ? _c('span', {
    staticClass: "vertical"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s('The ' + _vm.current.start_date.toDate().formatRange(_vm.current.days_running, false) + ' ' + _vm.locale.text_individual_days_sold_out + '<br>' + _vm.locale.text_subscribe_to_notify)
    }
  })]) : (_vm.current && _vm.current.package_state_id == 3 && !_vm.individual_days) ? _c('span', {
    staticClass: "vertical"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.$root.config.kings_phone_number
    },
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_individual_days_call_to_book + ' ' + _vm.current.start_date.toDate().formatRange(_vm.current.days_running, false))
    }
  })]) : (_vm.current && _vm.current.package_state_id == 4 && !_vm.individual_days) ? _c('span', {
    staticClass: "vertical"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.$root.config.kings_phone_number
    },
    domProps: {
      "innerHTML": _vm._s('The ' + _vm.current.start_date.toDate().formatRange(_vm.current.days_running, false) + ' ' + _vm.locale.text_individual_days_sold_out + '<br>' + _vm.locale.text_subscribe_to_notify)
    }
  })]) : (_vm.current && _vm.current.package_state_id == 5 && !_vm.individual_days) ? _c('span', {
    staticClass: "vertical"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.$root.config.kings_phone_number
    },
    domProps: {
      "innerHTML": _vm._s('The ' + _vm.current.start_date.toDate().formatRange(_vm.current.days_running, false) + ' ' + _vm.locale.text_individual_days_cancelled)
    }
  })]) : (_vm.selection.hour == null && _vm.selection.packages.length == 0 && !_vm.individual_days) ? _c('span', {
    staticClass: "vertical",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_error_hours)
    }
  }) : (_vm.selection.participants.length == 0) ? _c('span', {
    staticClass: "vertical",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_error_participant)
    }
  }) : (_vm.selection.packages.length == 0 && _vm.selection.participants.length == 0) ? _c('span', {
    staticClass: "vertical",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_error_package_and_participant)
    }
  }) : (_vm.selection.days_running.length == 0 && _vm.individual_days) ? _c('span', {
    staticClass: "vertical",
    domProps: {
      "innerHTML": _vm._s(_vm.$root.config.use_short_weeks ? _vm.locale.text_error_short_weeks : _vm.locale.text_error_days)
    }
  }) : (_vm.selection.packages.length == 0) ? _c('span', {
    staticClass: "vertical",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_error_package)
    }
  }) : _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x"
  })])])])])])])], 1)]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [(_vm.loading) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })]) : _c('div', {
    staticClass: "box-layout-inner"
  }, [_c('div', {
    staticClass: "title-block",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_empty)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-layout-inner yellow"
  }, [_c('div', {
    staticClass: "half-half"
  }, [_c('div', {
    staticClass: "full-width",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n                                Please select a minimum of 3 days per week\n                            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-590a9ffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/PackageOptions.vue
// module id = 177
// module chunks = 0